// ============================================
// 🔧 CONSTANTS.JS - Configurações Centralizadas
// ============================================
// ✅ CORRIGIDO: Usa proxy em desenvolvimento
// ============================================

// 🌐 BASE URL DA API
// DESENVOLVIMENTO: vazio (usa proxy do package.json)
// PRODUÇÃO: URL completa
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const API_BASE_URL = isDev ? '' : 'https://n8n.greentechsistemas.com';

// PostgREST — leitura direta do evolution_db
export const POSTGREST_URL     = process.env.REACT_APP_POSTGREST_URL     || 'http://localhost:3001';
export const POSTGREST_API_KEY = process.env.REACT_APP_POSTGREST_API_KEY || '';

// URL pública das mídias (MinIO bucket "evolution")
// Localmente: http://localhost:9000/evolution
// Produção: configurar REACT_APP_MIDIA_BASE_URL no Vercel apontando para o tunnel do MinIO
export const MIDIA_BASE_URL = process.env.REACT_APP_MIDIA_BASE_URL || 'http://localhost:9000/evolution';

// Helper para criar URL
const createWebhookUrl = (path) => `${API_BASE_URL}${path}`;

// 🔥 SUPABASE CONFIG — valores lidos do .env (nunca hardcoded aqui)
export const SUPABASE_URL      = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// MULTI-TENANT: domínio base usado para extração de subdomínio
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'integrai.com';

// 🧾 FISCAL — microserviço de emissão SEFAZ-BA (roda na VPS, fora da Vercel)
// Dev: localhost:4000. Produção: configurar REACT_APP_FISCAL_API_URL no Vercel
// (ex: https://fiscal.greentechsistemas.com) e liberar o host no CSP.
export const FISCAL_API_URL = process.env.REACT_APP_FISCAL_API_URL || 'http://localhost:4000';

// 🔑 API Keys — valores lidos do .env
export const IMGBB_API_KEY = process.env.REACT_APP_IMGBB_API_KEY;

// ============================================
// 📡 WEBHOOKS - CRM
// ============================================
export const WEBHOOKS = {
  // CRM - Clientes
  // MIGRADO → Supabase direto em 2026-09-26 (buscar/salvar/excluir observações)
  // MIGRADO → /api/resumo-conversa em 2026-09-26 (resumo IA)
  // MIGRADO → Supabase direto em 2026-02-28 (buscarStatusSupabase)
  // BUSCAR_STATUS_IA: createWebhookUrl('/webhook/buscar-status-ia'),

  // ATENDIMENTO IA
  LISTAR_INSTANCIAS: createWebhookUrl('/webhook/listar-instancias'),
  // MIGRADO → /api/enviar-mensagem em 2026-09-26 (webhook do n8n era público)
  // MIGRADO → Supabase direto (Controle_Atendimento) em 2026-09-26

  // DISPAROS
  // MIGRADO → /api/disparos em 2026-09-26 (salvar-config-disparo, salvar-config-disparo-perso,
  // disparador-master, disparador-personalizado, fila e agendamento)

  // CONFIG IA
  // MIGRADO → Supabase direto em 2026-02-28 (carregarConfigIA)
  // CONFIG_IA_BUSCAR: createWebhookUrl('/webhook/config-ia/buscar'),

  // MIGRADO → Supabase direto em 2026-09-26 (relatorio-disparos, stats/upload/gerenciar clientes)

  // CONTEXTO IA
  // MIGRADO → RPC agente_memoria_anexar em 2026-09-26 (salvar-contexto: a memória saiu do Redis)

  // ENTREGAS — Telegram Bot
  NOTIFICAR_ENTREGA_TELEGRAM: createWebhookUrl('/webhook/notificar-entrega-telegram'),

  // WHATSAPP
  CRIAR_INSTANCIA: createWebhookUrl('/webhook/criar-proxima-instancia'),
  GERAR_QR: createWebhookUrl('/webhook/gerar-qr-code'),
  EMBEDDED_SIGNUP: createWebhookUrl('/webhook/embedded-signup'),
};

// ============================================
// 📝 MENSAGENS FIXAS - NÃO EDITÁVEIS
// ============================================
export const mensagensPorGrupo = {
  'prazo-7': 'Olá, [NOME]!! 💧 Aqui é a Chama Gás e Água. Notamos que está chegando o momento em que você costuma reabastecer conosco. Já quer deixar seu pedido pronto? Estamos à disposição para atendê-lo com agilidade e qualidade de sempre! 🖤',
  'fora-ate-7': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Percebemos que você geralmente reabastece conosco por volta desta época, mas ainda não fez seu pedido. Está tudo bem? Caso precise, estamos aqui para ajudar e atender você com a maior rapidez! 💨',
  'fora-8-30': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Percebemos que você geralmente reabastece conosco, mas ainda não fez seu pedido. Está tudo bem?',
  'fora-31-60': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Percebemos que você geralmente reabastece conosco, porém já passou pouco mais de 01 mês do seu último pedido. Está tudo bem?',
  'fora-60': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Percebemos que você geralmente reabastece conosco, porém já tem um bom tempo que não comprou mais, poderia informar o motivo? sentimos sua falta.',
  'nao-recorrente-60': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Foi um prazer atender você recentemente! Que tal garantir o reabastecimento e aproveitar nossa entrega rápida? Estamos prontos para ajudar você! 🖤',
  'nao-recorrente-91': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Sentimos sua falta! Tem pouco mais de 90 dias da sua última compra, houve algum problema? Gostaríamos de voltar a lhe atender.',
  'nao-recorrente-150': 'Olá, [NOME]! 💧 Aqui é a Chama Gás e Água. Sentimos sua falta! Você só comprou uma vez com a gente ou houve 💭? O que podemos fazer para que possa comprar conosco novamente?'
};

// ============================================
// 🗺️ MAPEAMENTOS DE TIPOS E GRUPOS
// ============================================
export const mapeamentoGrupos = {
  '1.1': 'prazo-7',
  '1.2': 'fora-ate-7',
  '2.1': 'fora-8-30',
  '2.2': 'fora-31-60',
  '2.3': 'fora-60',
  '3.1': 'nao-recorrente-60',
  '3.2': 'nao-recorrente-91',
  '3.3': 'nao-recorrente-150'
};

export const opcoesDisparo = [
  { value: '1.1', label: 'Mensagem 1.1', grupo: 'GRUPO 1.1', grupoKey: 'prazo-7', cor: '#0fa968' },
  { value: '1.2', label: 'Mensagem 1.2', grupo: 'GRUPO 1.2', grupoKey: 'fora-ate-7', cor: '#f5a524' },
  { value: '2.1', label: 'Mensagem 2.1', grupo: 'GRUPO 2.1', grupoKey: 'fora-8-30', cor: '#c9820f' },
  { value: '2.2', label: 'Mensagem 2.2', grupo: 'GRUPO 2.2', grupoKey: 'fora-31-60', cor: '#e5484d' },
  { value: '2.3', label: 'Mensagem 2.3', grupo: 'GRUPO 2.3', grupoKey: 'fora-60', cor: '#c8373c' },
  { value: '3.1', label: 'Mensagem 3.1', grupo: 'GRUPO 3.1', grupoKey: 'nao-recorrente-60', cor: '#30b0e8' },
  { value: '3.2', label: 'Mensagem 3.2', grupo: 'GRUPO 3.2', grupoKey: 'nao-recorrente-91', cor: '#1078b0' },
  { value: '3.3', label: 'Mensagem 3.3', grupo: 'GRUPO 3.3', grupoKey: 'nao-recorrente-150', cor: '#005b8c' }
];

export const coresStatus = {
  'prazo-7': 'bg-green-500',
  'fora-ate-7': 'bg-yellow-500',
  'fora-8-30': 'bg-orange-500',
  'fora-31-60': 'bg-red-500',
  'fora-60': 'bg-red-700',
  'nao-recorrente-60': 'bg-purple-500',
  'nao-recorrente-91': 'bg-purple-600',
  'nao-recorrente-150': 'bg-purple-700'
};

export const configTipoMensagem = {
  'prazo-7': { tipo: 'Cliente em dia', cor: 'text-green-600' },
  'fora-ate-7': { tipo: 'Lembrete suave', cor: 'text-yellow-600' },
  'fora-8-30': { tipo: 'Lembrete intenso', cor: 'text-orange-600' },
  'fora-31-60': { tipo: 'Recuperação importante', cor: 'text-red-600' },
  'fora-60': { tipo: 'Recuperação urgente', cor: 'text-red-700' },
  'nao-recorrente-60': { tipo: 'Reativação -60 dias', cor: 'text-purple-600' },
  'nao-recorrente-91': { tipo: 'Reativação -91 dias', cor: 'text-purple-700' },
  'nao-recorrente-150': { tipo: 'Reativação -150 dias', cor: 'text-purple-800' }
};

export const tagsDisponiveis = ['VIP', 'Problema', 'Orçamento', 'Cancelamento', 'Urgente'];

export const configIAPadrao = {
  nome_base_conhecimento: 'Minha IA principal (Cópia)',
  nome_assistente: 'Ana',
  exibir_nome_inicio: true,
  modelo_ia: 'interno',
  modo_comunicar: 'direto',
  como_agir_nao_sabe: 'pedir_detalhes',
  como_iniciar_conversa: 'saudacao',
  alcance_informacoes: 'restrito',
  personalidade: 'empatico',
  missao_ia: 'Ajudar os usuários a encontrar e selecionar produtos ou serviços que atendam às suas necessidades.',
  responder_audio: false,
  condicao_audio: '',
  modelo_voz: 'Luna (Feminina - Formal)',
  nome_empresa: 'Chama Gás e Água',
  site: '',
  instagram: '',
  informacoes_negocio: '',
  regras_atendimento: '',
  horario_funcionamento: {
    segunda: { abertura: '07:00', fechamento: '17:00', ativo: true },
    terca: { abertura: '07:00', fechamento: '17:00', ativo: true },
    quarta: { abertura: '07:00', fechamento: '17:00', ativo: true },
    quinta: { abertura: '07:00', fechamento: '17:00', ativo: true },
    sexta: { abertura: '07:00', fechamento: '17:00', ativo: true },
    sabado: { abertura: '07:00', fechamento: '12:00', ativo: true },
    domingo: { abertura: '', fechamento: '', ativo: false }
  }
};

export const CLIENTES_POR_PAGINA = 10;
export const CONVERSAS_POR_PAGINA = 50;

// Régua idêntica à das views do banco (vw_relatorio_clientes / clientes_com_stats),
// que por sua vez reproduz a planilha do Painel CRM: as faixas comparam com valores
// INTEIROS. Dias restantes fracionários (ex.: -0,75 / -7,60 / -30,20 / -60,33) não
// casam em nenhuma faixa e caem em 'outros', igual à planilha e à aba de disparo.
const classificarRecorrente = (diasRestantes) => {
  if (diasRestantes >= 0 && diasRestantes <= 7) return 'prazo-7';
  if (diasRestantes >= -7 && diasRestantes <= -1) return 'fora-ate-7';
  if (diasRestantes >= -30 && diasRestantes <= -8) return 'fora-8-30';
  if (diasRestantes >= -60 && diasRestantes <= -31) return 'fora-31-60';
  if (diasRestantes <= -61) return 'fora-60';
  return null;
};

const classificarNaoRecorrente = (diasRestantes) => {
  if (diasRestantes >= -90 && diasRestantes <= -60) return 'nao-recorrente-60';
  if (diasRestantes >= -150 && diasRestantes <= -91) return 'nao-recorrente-91';
  if (diasRestantes <= -151) return 'nao-recorrente-150';
  return null;
};

export const classificarCliente = (cliente) => {
  const numeroCompras = cliente.numeroCompras || 0;
  const diasRestantes = cliente.diasRestantes || 0;

  if (numeroCompras >= 2) {
    const classe = classificarRecorrente(diasRestantes);
    if (classe) return classe;
  }

  if (numeroCompras === 1) {
    const classe = classificarNaoRecorrente(diasRestantes);
    if (classe) return classe;
  }

  return 'outros';
};

export const getStatusColor = (grupoId) => coresStatus[grupoId] || 'bg-gray-500';

export const getTipoMensagemConfig = (grupoId) => {
  const config = configTipoMensagem[grupoId];
  if (config) return { ...config, mensagem: mensagensPorGrupo[grupoId] };
  return { tipo: 'Outros', cor: 'text-gray-600', mensagem: 'Sem mensagem configurada' };
};

export const formatarTamanho = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const EXTENSOES_PERMITIDAS = ['.csv', '.xlsx', '.xls', '.xlsm', '.pdf'];

export const MODELO_CSV = `Data,Telefone,Nome
20/12/2024,73999999999,João Silva
21/12/2024,73888888888,Maria Santos
22/12/2024,73777777777,Pedro Oliveira`;
